import { render, staticRenderFns } from "./priceIndexControl.vue?vue&type=template&id=55dda01c&scoped=true"
import script from "./priceIndexControl.vue?vue&type=script&lang=js"
export * from "./priceIndexControl.vue?vue&type=script&lang=js"
import style0 from "./priceIndexControl.vue?vue&type=style&index=0&id=55dda01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dda01c",
  null
  
)

export default component.exports